export interface SnackbarStackEntry {
  id: string
  height: number
}

type Listener = (entries: SnackbarStackEntry[]) => void

const listeners = new Set<Listener>()
let entries: SnackbarStackEntry[] = []

function emit(): void {
  const snapshot = [...entries]
  listeners.forEach((listener) => listener(snapshot))
}

export function subscribeSnackbarStack(listener: Listener): () => void {
  listeners.add(listener)
  listener([...entries])
  return () => {
    listeners.delete(listener)
  }
}

export function upsertSnackbarStackEntry(id: string, height: number): void {
  const normalizedHeight = Math.max(1, Math.round(height))
  const index = entries.findIndex((entry) => entry.id === id)

  if (index === -1) {
    entries = [...entries, { id, height: normalizedHeight }]
    emit()
    return
  }

  if (entries[index]?.height === normalizedHeight) {
    return
  }

  entries = entries.map((entry, entryIndex) => (
    entryIndex === index ? { ...entry, height: normalizedHeight } : entry
  ))
  emit()
}

export function removeSnackbarStackEntry(id: string): void {
  const nextEntries = entries.filter((entry) => entry.id !== id)
  if (nextEntries.length === entries.length) {
    return
  }

  entries = nextEntries
  emit()
}
